import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { useIsLoggedIn } from '~/composables/_next/useIsLoggedIn';

// TODO: we should use `useUser` state to implement "isLoggedIn" (after VSF removal)
export default defineNuxtRouteMiddleware(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to) {
    var _useNuxt2App, $flag, localePath, _useIsLoggedIn, isLoggedIn;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _useNuxt2App = useNuxt2App(), $flag = _useNuxt2App.$flag, localePath = _useNuxt2App.localePath;
          _useIsLoggedIn = useIsLoggedIn(), isLoggedIn = _useIsLoggedIn.isLoggedIn;
          if (!(to.fullPath.includes('checkout') && $flag.get('guestCheckout'))) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          _context.next = 6;
          return isLoggedIn();
        case 6:
          if (!_context.sent) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return");
        case 8:
          return _context.abrupt("return", navigateTo(localePath({
            name: 'index'
          })));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());